import { deleteExistingDraftAgent } from '../utils';
import { useClearRecoilState } from './useClearRecoilState';

export const useClearForm = () => {
    const clearRecoilState = useClearRecoilState();

    return ({ removeAgentFromDB = true }: { removeAgentFromDB?: boolean } = {}) => {
        clearRecoilState();
        deleteExistingDraftAgent({ removeFromDB: removeAgentFromDB });
    };
};
